var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Ticket"},[_c('TopNavBar',{attrs:{"navtitle":"电子准考证"}}),_c('Ticket',{attrs:{"EF_ID":_vm.EF_ID}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }